import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// import { FlashMessagesModule } from 'angular2-flash-messages';
import { AppComponent } from './app.component';
import {routing} from './app.routing';
//import { TextMaskModule } from 'angular2-text-mask';
import { HttpClientModule } from '@angular/common/http';
import { 
  AngularTokenModule
} from '@lakshvairav/angular-token';

import {AuthModule} from './auth/auth.module';
// import {DndModule} from 'ngx-drag-drop';
// import { DragDropModule } from '@angular/cdk/drag-drop';
import { QuillModule } from 'ngx-quill';
// import {RoleGuard} from './home/role.guard';
// import {AdminModule} from './admin/admin.module';
// import {InstructorModule} from './Instructor/instructor.module';
// import {InstructorAdminModule} from './InstructorAdmin/instructor-admin.module';
// import {StudentModule} from './student/student.module';
import {SharedModule} from './shared/shared.module';
import {KeyValue} from './shared/key-value';
//import { NguiPopupModule } from '@ngui/popup';
import { environment } from '../environments/environment';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DndModule } from 'ngx-drag-drop';

import {  CSP_NONCE } from '@angular/core';

const nonce = (
    document.querySelector('meta[name="CSP_NONCE"]') as HTMLMetaElement
  )?.content;


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    routing,
    NgxMaskDirective,
    NgxMaskPipe,
    // FlashMessagesModule,
  
    // AdminModule,
    // InstructorModule,
    // InstructorAdminModule,
    // StudentModule,
    AuthModule,
    QuillModule.forRoot(),
    SharedModule.forRoot(),
    //NgxMaskModule.forRoot(),
    DndModule,
    //NguiPopupModule,
    //TextMaskModule,
    HttpClientModule,
    AngularTokenModule.forRoot({
      apiBase: environment.base_url
    })
  ],
  providers: [
    { provide: CSP_NONCE, useValue: nonce},
      AngularTokenModule,
    provideNgxMask(),
    KeyValue
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
